import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { HeaderProps, HeaderItemProps, HeaderSubItemProps } from './types';
import React from 'react';
import { classes, hasValidChildren } from '../../../lib';
import { FontAwesomeIcon } from '../../FontAwesomeIcon';
import Styles from './HeaderDesktop.module.less';
import CommonStyles from './Common.module.less';
import { LpLink } from '../LpLink';

export const HeaderSubItem = ({
    icon,
    title,
    href,
    children,
}: HeaderSubItemProps): JSX.Element => {
    return (
        <LpLink
            to={href}
            className={classes(Styles.subItem, 'vertical left-top g16')}>
            {icon}
            <strong>{title}</strong>
            <div className="secondary-text medium-alude">{children}</div>
        </LpLink>
    );
};

type ControllableHeaderItemProps = HeaderItemProps & {
    setOpen?: () => void;
    open?: boolean;
};

export const HeaderItem = ({
    children,
    text,
    href,
    open,
    setOpen,
}: ControllableHeaderItemProps): JSX.Element | null => {
    const hasChildren = children && hasValidChildren(children);
    const node = hasChildren ? (
        <>
            <div
                onClick={setOpen}
                className={classes(
                    Styles.item,
                    'horizontal text-center center-middle g8 pointer'
                )}>
                {text}
                <FontAwesomeIcon className={Styles.arrow} icon={faAngleDown} />
            </div>
            <div
                className={classes(
                    Styles.subHeader,
                    'py64',
                    !open && 'hidden'
                )}>
                <div className={Styles.subItems}>{children}</div>
            </div>
            <div
                onClick={setOpen}
                className={classes(Styles.overlay, !open && 'hidden')}
            />
        </>
    ) : (
        <LpLink to={href} className="horizontal center-middle">
            {text}
        </LpLink>
    );
    return <div className={classes(Styles.headerItem)}>{node}</div>;
};

export const Header = ({
    logo,
    loginButton,
    signupButton,
    children,
    hideMenu,
    hideButtons,
}: HeaderProps): JSX.Element => {
    return (
        <header
            className={classes(
                'mt-hidden vertical center-middle',
                CommonStyles.header
            )}>
            <div
                className={classes(
                    Styles.container,
                    'horizontal between-middle px32'
                )}>
                <div className="horizontal left-middle g24">
                    {logo}
                    <div
                        className={classes(
                            Styles.items,
                            'horizontal center-middle'
                        )}>
                        {!hideMenu && children}
                    </div>
                </div>
                {!hideButtons && (
                    <div className="horizontal left-middle g8">
                        {loginButton}
                        {signupButton}
                    </div>
                )}
            </div>
        </header>
    );
};
